import { MouseEvent, useState } from "react";
import { Edit2, Trash2 } from "react-feather";
import { useTheme } from "styled-components";
import { Button } from "styles/Button";
import { AgentAbsence } from "types/SupportAgent";
import { useDeleteAgentAbsence } from "hooks/mutations/useDeleteAgentAbsence";
import { EditAbsenceModal } from "components/EditAbsenceModal";
import { ActionsButtons } from "components/ManageMacroModal/styles";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import Swal from "sweetalert2";

type Props = {
  absence: AgentAbsence;
};

function formatDate(dateStr: string) {
  try {
    return format(parseISO(dateStr), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
  } catch {
    return dateStr;
  }
}

export function AbsenceCard({ absence }: Props) {
  const theme = useTheme();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const deleteAbsence = useDeleteAgentAbsence();

  async function handleDelete(e: MouseEvent) {
    e.stopPropagation();

    const result = await Swal.fire({
      title: 'Remover ausência?',
      text: `Deseja remover o período de ausência de ${absence.user?.name}?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Remover',
      confirmButtonColor: theme.colors.danger,
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;
    await deleteAbsence.mutateAsync(absence);
  }

  return (
    <>
      <tr>
        <td>{absence.user?.name ?? '—'}</td>
        <td>{absence.reason ?? '—'}</td>
        <td>{formatDate(absence.starts_at)}</td>
        <td>{formatDate(absence.ends_at)}</td>
        <td>{absence.auto_reactivate ? 'Sim' : 'Não'}</td>
        <td>
          <ActionsButtons>
            <Button small onClick={(e) => { e.stopPropagation(); setIsEditModalOpen(true); }}>
              <Edit2 color={theme.colors.buttonText} size="16" />
            </Button>
            <Button small onClick={handleDelete}>
              <Trash2 color={theme.colors.buttonText} size="16" />
            </Button>
          </ActionsButtons>
        </td>
      </tr>

      <EditAbsenceModal
        isOpen={isEditModalOpen}
        onRequestClose={() => setIsEditModalOpen(false)}
        absence={absence}
      />
    </>
  );
}
